module.exports = __webpack_public_path__ + "static/img/popup_perl.74c58dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/customer/duschking-configurator/shower_tray/popup_perl.png
// module id = vtRK
// module chunks = 12